// Email stubs - will be connected to Resend later
// PII is only logged in development to avoid information disclosure in production

const devLog = (label: string, payload: Record<string, unknown>) => {
  if (import.meta.env.DEV) {
    console.log(`[EMAIL STUB] ${label}:`, payload);
  }
};

export const sendRegistrationConfirmation = async (email: string, name: string) => {
  devLog('Registration Confirmation', {
    to: email,
    subject: 'Installer Registration Received',
    body: `Thank you for registering, ${name}. Please review and accept the Installer Agreement to unlock technical documents.`,
  });
  return { success: true };
};

export const sendDocumentAccessGranted = async (email: string, name: string) => {
  devLog('Document Access Granted', {
    to: email,
    subject: 'Installer Document Access Granted',
    body: `Your installer access is now active, ${name}. You can now download installation guides and technical documents.`,
  });
  return { success: true };
};

export const sendCertificationInvite = async (email: string, name: string) => {
  devLog('Certification Invite', {
    to: email,
    subject: 'Invitation to Certified Installer Program',
    body: `Based on your experience, ${name}, you are invited to apply for our Certified Installer Program.`,
  });
  return { success: true };
};

export const sendCertificationApproved = async (email: string, name: string) => {
  devLog('Certification Approved', {
    to: email,
    subject: 'Certified Installer Status Approved',
    body: `Congratulations ${name}! You are now a Certified Installer. You can be referred to customers and listed as a preferred partner.`,
  });
  return { success: true };
};
